/* tslint:disable */
/* eslint-disable */
/**
 * home-health-api
 * home-health-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { HchbPatientRequestSummary } from './HchbPatientRequestSummary';
import {
    HchbPatientRequestSummaryFromJSON,
    HchbPatientRequestSummaryFromJSONTyped,
    HchbPatientRequestSummaryToJSON,
} from './HchbPatientRequestSummary';

/**
 * 
 * @export
 * @interface CreateHchbPatientRequest201Response
 */
export interface CreateHchbPatientRequest201Response {
    /**
     * 
     * @type {HchbPatientRequestSummary}
     * @memberof CreateHchbPatientRequest201Response
     */
    data?: HchbPatientRequestSummary;
}

/**
 * Check if a given object implements the CreateHchbPatientRequest201Response interface.
 */
export function instanceOfCreateHchbPatientRequest201Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function CreateHchbPatientRequest201ResponseFromJSON(json: any): CreateHchbPatientRequest201Response {
    return CreateHchbPatientRequest201ResponseFromJSONTyped(json, false);
}

export function CreateHchbPatientRequest201ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateHchbPatientRequest201Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : HchbPatientRequestSummaryFromJSON(json['data']),
    };
}

export function CreateHchbPatientRequest201ResponseToJSON(value?: CreateHchbPatientRequest201Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': HchbPatientRequestSummaryToJSON(value.data),
    };
}

